module.exports = __webpack_public_path__ + "fonts/righthand-bolditalic-personal.590c7fc3.ttf";